import React, { useState } from "react";
import { FiTrash2 } from "react-icons/fi";
import { motion } from "framer-motion";
import "styles/teacher.css";
import PanelLayout from "layouts/PanelLayout";

const ResultTable = ({ goBack }) => {
  const [results, setResults] = useState([
    {
      id: 1,
      name: "Abdullayev Azizbek",
      correct: 18,
      incorrect: 2,
      unanswered: 0,
      time: "12:45",
    },
    {
      id: 2,
      name: "Sodiqova Madina",
      correct: 15,
      incorrect: 3,
      unanswered: 2,
      time: "13:02",
    },
    {
      id: 3,
      name: "Karimov Doston",
      correct: 20,
      incorrect: 0,
      unanswered: 0,
      time: "11:57",
    },
    {
      id: 4,
      name: "Rasulova Dilnoza",
      correct: 17,
      incorrect: 2,
      unanswered: 1,
      time: "12:10",
    },
  ]);

  const handleDelete = (id) => {
    if (!window.confirm("Natijani o‘chirishni xohlaysizmi?")) return;
    setResults((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <PanelLayout>
      <div className="subject-page">
        <div className="tests-header">
          <div className="breadcrumb">
            <span
              style={{ cursor: "pointer" }}
              onClick={goBack || (() => window.history.back())}
            >
              Natijalar
            </span>
            <span className="divider">/</span>
            <span className="current">Test natijalari</span>
          </div>
        </div>

        <motion.div
          className="table-container"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <table className="banner-table">
            <thead>
              <tr>
                <th>№</th>
                <th>Familya, Ism</th>
                <th>To‘g‘ri</th>
                <th>Noto‘g‘ri</th>
                <th>Belgilanmagan</th>
                <th>Vaqt</th>
                <th>Amallar</th>
              </tr>
            </thead>
            <tbody>
              {results.map((result, index) => (
                <tr key={result.id}>
                  <td>{index + 1}</td>
                  <td>{result.name}</td>
                  <td>{result.correct}</td>
                  <td>{result.incorrect}</td>
                  <td>{result.unanswered}</td>
                  <td>{result.time}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                        justifyContent: "center",
                      }}
                    >
                      <FiTrash2
                        size={18}
                        style={{ cursor: "pointer", color: "#ef4444" }}
                        onClick={() => handleDelete(result.id)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {results.length === 0 && (
            <div
              className="empty-state"
              style={{ textAlign: "center", padding: "60px 0" }}
            >
              <p>Hozircha natijalar mavjud emas</p>
            </div>
          )}
        </motion.div>
      </div>
    </PanelLayout>
  );
};

export default ResultTable;
